// TODO @Israel Should add design for size
export enum PerfectInputSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
}
